import { cn } from '@/lib/utils';
import type { CoopScanDetail } from '../lib/coopDelivery';

/**
 * Label/value rows for Coop delivery state. Keeps attempt, last retry, next retry
 * and the error on their own lines instead of one wrapping sentence.
 */
export function CoopScanDetails({
  details,
  className,
}: {
  details: CoopScanDetail[];
  className?: string;
}) {
  if (details.length === 0) return null;

  return (
    <dl className={cn('grid grid-cols-[auto_minmax(0,1fr)] gap-x-2 gap-y-0.5 text-xs', className)}>
      {details.map((detail) => (
        <div key={detail.label} className="col-span-2 grid grid-cols-subgrid">
          <dt className="text-muted-foreground">{detail.label}</dt>
          <dd
            className={cn(
              'min-w-0 break-words tabular-nums',
              detail.tone === 'error' ? 'text-destructive' : 'text-foreground',
            )}
            {...(detail.title ? { title: detail.title } : {})}
          >
            {detail.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
